import { Divider } from "@mui/material";
import { ReportTypesEnum } from "types/enums";
import { TimeRangeFinite } from "types/types";
import {
  useShifts,
  useWorkScheduleIdOnCurrentPage,
} from "utils/customHooks/genericHooks";
import { getShiftName as formatShiftName } from "../Dashboard/range-selectors/steppable-range-selectors/ShiftSelector/shiftUtils";
import PerformanceSummaryListItem from "./PerformanceSummaryListItem";
import { ReportScheduleType } from "./reportPageTypes";

export default function ReportItems({
  range,
  name,
  reportGroups,
  reportPath = "eos",
  reportScheduleType,
  reportSubPath,
  shouldGroupByMachineGroup,
}: {
  range: TimeRangeFinite;
  name: string;
  reportScheduleType: ReportScheduleType;
  shouldGroupByMachineGroup: boolean;
  reportGroups?: string[];
  reportPath?: string;
  reportSubPath?: string;
}) {
  const workScheduleId = useWorkScheduleIdOnCurrentPage();
  const scheduleParam = workScheduleId ? `&workSchedule=${workScheduleId}` : "";
  const { ge, lt } = range;
  const getReportLink = (subPath?: string) => {
    return subPath
      ? `${reportPath}/${subPath}?ge=${ge}&lt=${lt}${scheduleParam}`
      : `${reportPath}?ge=${ge}&lt=${lt}${scheduleParam}`;
  };

  // get unique shift names
  const shifts = useShifts()
    .map(({ shift }) => {
      return shift.name;
    })
    .filter((val, index, arr) => arr.indexOf(val) === index);

  const reportGroupsIncludesShift = reportGroups?.every(group =>
    shifts.includes(group)
  );

  const performanceSummaryListItemProps = {
    ge,
    lt,
    name,
    reportType:
      reportPath === "eos"
        ? ReportTypesEnum.standardEos
        : ReportTypesEnum.custom,
    reportScheduleType,
  };

  return reportGroups && !shouldGroupByMachineGroup ? (
    <>
      {reportGroups.map(reportGroup => {
        return (
          <PerformanceSummaryListItem
            key={reportGroup}
            {...{
              ...performanceSummaryListItemProps,
              portalReportPath: getReportLink(encodeURIComponent(reportGroup)),
              reportGroup,
              ...(reportGroupsIncludesShift && {
                customReportTitle: `${name} - ${formatShiftName(reportGroup)}`,
              }),
            }}
          />
        );
      })}
      <Divider />
    </>
  ) : (
    <>
      <PerformanceSummaryListItem
        key={ge}
        portalReportPath={getReportLink(
          reportSubPath ? encodeURIComponent(reportSubPath) : undefined
        )}
        {...performanceSummaryListItemProps}
      />
      <Divider />
    </>
  );
}
